import { captureException } from '@sentry/vue';

class AssertionError extends Error {
  constructor(...options: ConstructorParameters<typeof Error>) {
    super(...options);
    this.message = `[ASSERTION ERROR] ${this.message}`;
  }
}

export function assert(condition: unknown, message: string): asserts condition {
  if (!condition) {
    const error = new AssertionError(message);
    console.error(error);
    captureException(error);
  }
}

export function assertDefined(value: unknown, key = 'value'): asserts value {
  if (value === null || value === undefined) {
    const error = new AssertionError(`Expected '${key}' to be defined. Found ${value}`);
    console.error(error);
    captureException(error);
  }
}

/** @deprecated */
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class Assertions {
  public static defined(value: any, key = 'value'): asserts value {
    if (value === null || value === undefined) {
      console.error(new Error(`Expected ${key} to be defined. Found ${value}`));
      captureException(new Error(`Expected ${key} to be defined. Found ${value}`));
    }
  }
}
